import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManipulationsToolbarComponent } from 'src/app/shared/components/manipulations-toolbar/manipulations-toolbar.component';
import { ReportStore } from '../../store/report-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { ReportsListItemComponent } from "../reports-list-item/reports-list-item.component";
import { ReportsListHeaderComponent } from "../reports-list-header/reports-list-header.component";
import { NoResultComponent } from "src/app/shared/components/no-result/no-result.component";
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { ReportSort, ReportSortBy } from '../../../../models/report.model';
import { SortDirection } from '../../../../models/approval.model';

@Component({
  selector: 'que-reports-list',
  imports: [CommonModule, ManipulationsToolbarComponent, ReportsListItemComponent, ReportsListHeaderComponent, NoResultComponent],
  templateUrl: './reports-list.component.html',
  styleUrls: ['./reports-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportsListComponent {
  #reportStore = inject(ReportStore);
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  readonly sort = signal<ReportSort>({
    sortBy: ReportSortBy.SentDate,
    sortDirection: SortDirection.Desc,
  });
  reports$ = toSignal(this.#reportStore.reports$)
  loading$ = toSignal(this.#reportStore.loading$);
  loadingExtra$ = toSignal(this.#reportStore.loadingExtra$);
  isEmpty$ = toSignal(this.#reportStore.isEmpty$);
  isResult$ = toSignal(this.#reportStore.totals$.pipe(map(x => x != undefined && x > 0)));
  isFilterListOpen$ = toSignal(this.#manipulationsToolbarStore.isFilterListOpen$);
  reportsExtra$ = toSignal(this.#reportStore.reportsExtra$);
  constructor(private el: ElementRef) {
  }

  @HostListener('document:mousewheel', ['$event'])
  onWindowScroll(event: any) {
    const scrollContainer = this.el.nativeElement.querySelector('.scroll');
    if (scrollContainer) {
      const scrollBottom = scrollContainer.scrollHeight - scrollContainer.clientHeight;
      if (scrollContainer.scrollTop >= scrollBottom - 1) {
        var is10InExtra = this.reportsExtra$()?.result.length == 10;
        if (this.reportsExtra$()?.result && this.reportsExtra$()!.result.length > 0) {
          this.#reportStore.updateReportsWithExtra();
        }
        if (this.reportsExtra$() && is10InExtra && !this.loadingExtra$())
          this.loadMore();
      }
    }
  }
  onSortChange(sortBy: ReportSortBy): void {
    const currentSort = this.sort();

    const sortDirection =
      currentSort.sortBy === sortBy
        ? currentSort.sortDirection === SortDirection.Asc
          ? SortDirection.Desc
          : SortDirection.Asc
        : SortDirection.Asc;

    const newSort: ReportSort = {
      sortBy,
      sortDirection,
    };

    this.sort.set(newSort);
    this.#reportStore.changeSort(newSort);
  }
  loadMore() {
    this.#reportStore.loadReportsExtra();
  }
}
